import React, { FC, useEffect } from 'react'
import style from './style.module.less'
import { useLocalStore, Observer } from 'mobx-react'
import Api from '@api/marketing'
import { Spin } from 'hljd'
/**
 *
 * @author  Ta_Mu
 * @date 2021/5/21 11:20
 */

const checkBoxList = [
  {name: '基础店铺功能', basic: true, grow: true, featured: true},
  {name: '可视化数据报表', basic: false, grow: true, featured: true},
  {name: '一对一营销顾问', basic: false, grow: true, featured: true},
  {name: '官方标识', basic: false, grow: true, featured: true},
]

type VersionPriceType = {
  price: number,
  month: number
}

interface IStoreProps {
  pageLoading: boolean,
  growthVersion: VersionPriceType, // 成长版价格
  growthAverage: number, // 成长版月均
  growthPackage: number, // 成长版流量包
  featuredVersion: VersionPriceType, // 精选版价格
  featuredAverage: number, // 精选版月均
  featuredPackage: number, // 精选版月均
  requestPriceData: () => void
}

const PriceTable: FC = () => {

  const store = useLocalStore<IStoreProps>(() => ({
    pageLoading: false,
    growthVersion: {
      price: 0,
      month: 0
    },
    growthAverage: 0,
    growthPackage: 0,
    featuredVersion: {
      price: 0,
      month: 0
    },
    featuredAverage: 0,
    featuredPackage: 0,
    requestPriceData: async () => {
      store.pageLoading = true
      const { success, data } = await Api.getWuDaPrices()
      store.pageLoading = false
      if(success) {
        store.growthVersion = {
          price: data?.priceTotal?.growth?.price,
          month: data?.priceTotal?.growth?.months
        }
        store.growthAverage = data?.priceMonth?.growth?.price
        store.growthPackage = data?.flowValue?.growth?.price

        store.featuredVersion = {
          price: data?.priceTotal?.selection?.price,
          month: data?.priceTotal?.selection?.months
        }
        store.featuredAverage = data?.priceMonth?.selection?.price
        store.featuredPackage = data?.flowValue?.selection?.price
      }
    }
  }))

  useEffect(() => {
    store.requestPriceData()
  }, [])

  return (
    <Observer>
      {
        () => (
          <div className={style.tableContainer}>
            <Spin spinning={store.pageLoading}>
              <table className={style.table}>
                <thead>
                <tr>
                  <th>功能对比</th>
                  <th>基础版</th>
                  <th>
                    <div>成长版</div>
                    <div className={style.priceDesc}>（{store.growthVersion.price}元 / {store.growthVersion.month}个月）</div></th>
                  <th>
                    <div>精选版</div>
                    <div className={style.priceDesc}>（{store.featuredVersion.price}元 / {store.featuredVersion.month}个月）</div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>月均价格</td>
                  <td><div className={style.horizontalLine}/></td>
                  <td className={style.hint}>{store.growthAverage}元/月</td>
                  <td className={style.highlight}>{store.featuredAverage}元/月</td>
                </tr>
                <tr>
                  <td>配送流量包价值</td>
                  <td><div className={style.horizontalLine}/></td>
                  <td className={style.hint}>{store.growthPackage}元</td>
                  <td className={style.highlight}>{store.featuredPackage}元</td>
                </tr>
                {
                  checkBoxList.map(item => (
                    <tr key={item.name}>
                      <td>{item.name}</td>
                      <td><CheckBox checked={item.basic}/></td>
                      <td><CheckBox checked={item.grow}/></td>
                      <td><CheckBox checked={item.featured}/></td>
                    </tr>
                  ))
                }
                </tbody>
              </table>
            </Spin>
          </div>
        )
      }
    </Observer>
  )
}

const CheckBox = ({ checked = true }) => {

  if(checked) {
    return (
      <img src='https://qnm.hunliji.com/camel-35660b2d-4a9e-479b-b1a8-09f1390d15bb.png' alt='' className={style.checkbox}/>
    )
  }
  return (
    <div className={style.uncheckedBox}/>
  )
}

export default PriceTable
